import { render, staticRenderFns } from "./ProductsServices.vue?vue&type=template&id=6f18a09a&scoped=true"
import script from "./ProductsServices.vue?vue&type=script&lang=js"
export * from "./ProductsServices.vue?vue&type=script&lang=js"
import style0 from "./ProductsServices.vue?vue&type=style&index=0&id=6f18a09a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f18a09a",
  null
  
)

export default component.exports